export const ComputeOperatorsData = [
     { value: ">", label: ">" },
     { value: "<", label: "<" },
     { value: "==", label: "==" },
     { value: ">=", label: ">=" },
     { value: "<=", label: "<=" },
     { value: "!=", label: "!=" },
     { value: "contains", label: "contains" },
     { value: "&&", label: "&&" },
     { value: "||", label: "||" },
     { value: "and", label: "and" },
     { value: "or", label: "or" },
     { value: "not", label: "not" },
     { value: "in", label: "in" },
     { value: "+", label: "+" },
     { value: "-", label: "-" },
     { value: "*", label: "*" },
     { value: "/", label: "/" },
     { value: "%", label: "%" },
     { value: "(", label: "(" },
     { value: ")", label: ")" },
     { value: "[", label: "[" },
     { value: "]", label: "]" },
     { value: "**(1/2)", label: "sqrt" },
     { value: "**2", label: "square" },
     { value: "**3", label: "cube" },
     { value: "**", label: "power" },
     { value: ":", label: ":" },
     { value: "reset", label: "reset" },
     { value: "autofillcurrentDate", label: "autofillcurrentDate" },
     { value: "currentdate", label: "currentdate" },
     { value: "validationrule", label: "validationrule" },
     { value: "autofillrule", label: "autofillrule" },
     { value: "alertrule", label: "alertrule" },
     { value: "calculateDiffInYear", label: "calculateDiffInYear" },
     { value: "calculateDiffInMonth", label: "calculateDiffInMonth" },
     { value: "splitDataAndConcat", label: "splitDataAndConcat" },
     { value: "fillBMIGroup", label: "fillBMIGroup" },
     {value: "fillWaistGroup", label: "fillWaistGroup"},
     {value: "calculateAgeInDays", label: "calculateAgeInDays"},
     {value: "sumationOfFieldValues", label: "sumationOfFieldValues"}
];


export const colorCodes = [
     { code: '#FF6262', value: 'red', label: 'color-red', priority: 1 },
     { code: '#FF6262', value: 'red-block', label: 'color-red-block', priority: 1 },
     { code: '#fccf7c', value: 'orange', label: 'color-orange', priority: 2 },
     { code: '#fccf7c', value: 'orange-block', label: 'color-orange-block', priority: 2 },
     { code: '#faeda2', value: 'yellow', label: 'color-yellow', priority: 3 },
     { code: '#faeda2', value: 'yellow-block', label: 'color-yellow-block', priority: 3 },
     { code: '#BDEDCB', value: 'green', label: 'color-green', priority: 4 },
     { code: '#BDEDCB', value: 'green-block', label: 'color-green-block', priority: 4 },
     { code: '#FFFFFF', value: 'white', label: 'color-white', priority: 5 },
     { code: '#FFFFFF', value: 'white-block', label: 'color-white-block', priority: 5 }
]

